module.exports = "<div mk-morris-js [options]=\"chartBarOptions\" [data]=\"chartBarData\" type=\"Bar\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/bar-chart/bar-chart.component.html
// module id = ./src/app/shared/component/bar-chart/bar-chart.component.html
// module chunks = main